module.exports = __webpack_public_path__ + "img/lg_ring_y_skip_null_1.b1c3cd36.png";